import { api } from '../api/client';
import type { UserInfo } from '../api/types';

export interface LoginResponse {
  step: 'MFA_REQUIRED' | 'COMPLETE';
  mfaToken?: string;
  accessToken?: string;
  refreshToken?: string;
  user?: UserInfo;
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>('/auth/login', { email, password }).then((r) => r.data),
  verify: (mfaToken: string, code: string) =>
    api
      .post<LoginResponse>('/auth/mfa/verify', { code }, { headers: { 'X-MFA-Token': mfaToken } })
      .then((r) => r.data),
  logout: (refreshToken: string) => api.post('/auth/logout', { refreshToken }),
  me: () => api.get<UserInfo>('/auth/me').then((r) => r.data),
};
